import './index.scss';
import { bool, func, object } from 'prop-types';
import React from 'react';
import PDFViewer from '~/components/old_pdf_viewer';
import clausesToBookmarks from '~/utils/clausesToBookmarks';
const DocumentPanel = ({ activeClause, document, setIsDocumentRendered, isDocumentLoading }) => {
    DocumentPanel.propTypes = {
        activeClause: object,
        document: object.isRequired,
        isDocumentLoading: bool.isRequired,
        setIsDocumentRendered: func,
    };
    if ((!document || Object.keys(document).length === 0) || isDocumentLoading) {
        return (React.createElement("span", null,
            React.createElement("i", { className: 'fas fa-spin fa-spinner' })));
    }
    const allBookmarks = clausesToBookmarks(document.clauses);
    let bookmarks = [];
    if (activeClause) {
        bookmarks = allBookmarks.filter(bookmark => bookmark.id === activeClause.id);
    }
    const documentReady = { value: true };
    return (React.createElement("div", { className: 'document-panel' },
        React.createElement("h2", null, document.fileName),
        React.createElement(PDFViewer, { document: document, bookmarks: bookmarks, setIsDocumentRendered: setIsDocumentRendered, documentReady: documentReady, type: 'single' })));
};
export default DocumentPanel;
